<section *ngIf="data.success">
	<section *ngIf="shouldAddLineSeparator" class="section-separator"></section>
	<h3 class="title-main" dcrHTMLKey="FUND_PERFORMANCE" data-cy="fund-performance">Fund Performance</h3>
	<section class="disclaimer-container" dcrHTMLKey="FUND_PERFORMANCE_STOCKS_DISC">Applicable to Mutual Funds, Closed End Funds, Money Market Funds and ETFs.</section>

	<section class="row">
		<section class="col-24 col-md-12 col-sm-24">
			<section class="ac-dropdown" *ngIf="data.portfolioData && data.portfolioData.length > 1">
				<label class="text-11 d-block" dcrHTMLKey="SELECT_PORTFOLIO_OR_BENCHMARK">Select Portfolio</label>
				<select (change)="selectPortfolioToView($event.target.value)">
					<option *ngFor="let portfolio of validPortfolioData; index as i" [value]="i">
						<ng-container *ngIf="mode === 'rebalance' && (i === 0 || i === 1)">
							<section [innerHTML]="holdingsAsOfDateData[0].cells[0][i].formattedValue | portfolioDisplayNameRebal : portfolio"></section>
						</ng-container>
						<ng-container *ngIf="mode !== 'rebalance' || i > 1">
							<section *ngFor="let cell of portfolio">
								<section *ngIf="cell?.config.visible && cell?.config.id === 'name'">{{ cell.formattedValue }}</section>
							</section>
						</ng-container>
					</option>
				</select>
			</section>
		</section>
	</section>

	<section class="margin-standard" *ngIf="data.tabs && data.tabs.length">
		<bfa-tabs type="underline">
			<ng-container *ngFor="let tab of data.tabs; index as tabIndex">
				<ng-template #table>
					<dcr-cell-content [config]="tab.config.title"></dcr-cell-content>
					<ng-container *ngFor="let tableData of tab.tableData; index as i">
						<data-table
							*ngIf="i === selectedPortfolioIndex"
							[tableData]="tableData"
							[sortable]="true"
							[filter]="filterTerm"
							[searchFormControl]="searchFormControl"
							[showPagination]="showPagination"
							[defaultPageSize]="defaultPageSize"
							[renderPSView]="true"
							[defaultSortKey]="defaultSortKey"
						></data-table>
					</ng-container>
				</ng-template>
				<tab-panel [tab-title]="tab.config.title.label" [templateRef]="table"></tab-panel>
			</ng-container>
		</bfa-tabs>
		<span class="no-performance text-14" *ngIf="data.tabs[0].tableData[selectedPortfolioIndex].cells.length <= 0" dcrHTMLKey="NO_FUND_PERFORMANCE_DATA_AVAILABLE">
			Fund performance is unavailable for this portfolio because it does not include Mutual Funds, Closed End Funds, Money Market Funds, or ETFs.
		</span>
	</section>
	<section class="fund-perf-disclaimer">
		<ac-tpm-disclosure></ac-tpm-disclosure>
		<div class="text-condensed-14" dcrHTMLKey="FUND_PERF_DISCLAIMER">
			+ For ETFs and Closed End Funds only <br />
			‡ For Mutual Funds only<br />
			<strong
				>The performance quoted represents past performance and does not guarantee future results. Investment return and principal value of an investment will fluctuate so
				that an investor’s shares, when sold or redeemed, may be worth more or less than the original cost. Current performance may be lower or higher than the performance
				quoted. Performance data current to the most recent month end for the BlackRock and iShares Funds may be obtained by visiting www.blackrock.com or www.iShares.com.
			</strong>
			Shares of ETFs are bought and sold at market price (not NAV) and are not individually redeemed from the Fund. Brokerage commissions will reduce returns. Market returns
			are based upon the midpoint of the bid/ask spread at 4:00 p.m. eastern time (when NAV is normally determined for most ETFs), and do not represent the returns you would
			receive if you traded shares at other times. Source: Morningstar
		</div>
	</section>
</section>
